import {
    CHANGE_KMS_DOCUMENT_STATUS_FAIL,
    CHANGE_KMS_DOCUMENT_STATUS_SUCCESS,
    ARCHIVE_KMS_DOCUMENT_FAIL,
    CLEAR_KMS_DOCUMENT_ERROR,
    CLEAR_KMS_DOCUMENT_MESSAGE,
    DELETE_KMS_DOCUMENT_FAIL,
    DELETE_KMS_DOCUMENT_SUCCESS,
    GET_KMS_ARCHIVED_DOCUMENTS_FAIL,
    GET_KMS_ARCHIVED_DOCUMENTS_SUCCESS,
    GET_KMS_DOCUMENTS_FAIL,
    GET_KMS_DOCUMENTS_SUCCESS,
    GET_KMS_TRASHED_DOCUMENTS_FAIL,
    GET_KMS_TRASHED_DOCUMENTS_SUCCESS,
    GET_KMS_DOCUMENT_FAIL,
    GET_KMS_DOCUMENT_COMMENTS_FAIL,
    GET_KMS_DOCUMENT_COMMENTS_SUCCESS,
    GET_KMS_DOCUMENT_RATING_SUMMARY_FAIL,
    GET_KMS_DOCUMENT_RATING_SUMMARY_SUCCESS,
    GET_KMS_DOCUMENT_SUBSCRIPTION_FAIL,
    GET_KMS_DOCUMENT_SUBSCRIPTION_SUCCESS,
    GET_KMS_DOCUMENT_SUCCESS,
    GET_KMS_DOCUMENTS_BY_CONTENT_FAIL,
    GET_KMS_DOCUMENTS_BY_CONTENT_SUCCESS,
    GET_KMS_DOCUMENTS_BY_REPERTOIRE_FAIL,
    GET_KMS_DOCUMENTS_BY_REPERTOIRE_SUCCESS,
    HARD_DELETE_KMS_DOCUMENT_FAIL,
    HARD_DELETE_KMS_DOCUMENT_SUCCESS,
    CREATE_KMS_DOCUMENT_COMMENT_FAIL,
    CREATE_KMS_DOCUMENT_COMMENT_SUCCESS,
    DELETE_KMS_DOCUMENT_COMMENT_FAIL,
    DELETE_KMS_DOCUMENT_COMMENT_SUCCESS,
    RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_FAIL,
    RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_SUCCESS,
    RESTORE_KMS_DOCUMENT_FROM_TRASH_FAIL,
    RESTORE_KMS_DOCUMENT_FROM_TRASH_SUCCESS,
    SET_KMS_DOCUMENT_DETAIL_LOADING,
    SET_KMS_DOCUMENT_LIST_LOADING,
    SET_KMS_DOCUMENT_SAVE_LOADING,
    SUBSCRIBE_KMS_DOCUMENT_FAIL,
    SUBSCRIBE_KMS_DOCUMENT_SUCCESS,
    UNSUBSCRIBE_KMS_DOCUMENT_FAIL,
    UNSUBSCRIBE_KMS_DOCUMENT_SUCCESS,
    UPSERT_KMS_DOCUMENT_RATING_FAIL,
    UPSERT_KMS_DOCUMENT_RATING_SUCCESS,
    UPLOAD_KMS_DOCUMENT_TO_CONTENT_FAIL,
    UPLOAD_KMS_DOCUMENT_TO_CONTENT_SUCCESS,
    UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_FAIL,
    UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_SUCCESS,
    UPDATE_KMS_DOCUMENT_FAIL,
    UPDATE_KMS_DOCUMENT_SUCCESS,
} from "../actions/kmsDocumentActions";

const initialState = {
    items: [],
    archivedItems: [],
    trashedItems: [],
    lastFilters: {},
    byRepertoire: {},
    byContent: {},
    commentsByDocument: {},
    subscriptionByDocument: {},
    ratingSummaryByDocument: {},
    commentsLoadingByDocument: {},
    subscriptionLoadingByDocument: {},
    ratingLoadingByDocument: {},
    commentsErrorByDocument: {},
    subscriptionErrorByDocument: {},
    ratingErrorByDocument: {},
    commentSaveLoadingByDocument: {},
    subscriptionSaveLoadingByDocument: {},
    ratingSaveLoadingByDocument: {},
    commentMutationTickByDocument: {},
    subscriptionMutationTickByDocument: {},
    ratingMutationTickByDocument: {},
    currentDocument: null,
    listLoading: false,
    detailLoading: false,
    saveLoading: false,
    message: "",
    error: null,
};

export default function kmsDocumentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_KMS_DOCUMENT_LIST_LOADING:
            return { ...state, listLoading: action.payload };
        case SET_KMS_DOCUMENT_DETAIL_LOADING:
            return { ...state, detailLoading: action.payload };
        case SET_KMS_DOCUMENT_SAVE_LOADING:
            return { ...state, saveLoading: action.payload };

        case "SET_KMS_DOCUMENT_COMMENTS_LOADING":
            return {
                ...state,
                commentsLoadingByDocument: {
                    ...state.commentsLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
                commentsErrorByDocument: {
                    ...state.commentsErrorByDocument,
                    [action.payload.documentId]: action.payload.loading
                        ? null
                        : state.commentsErrorByDocument[action.payload.documentId],
                },
            };

        case "SET_KMS_DOCUMENT_COMMENT_SAVE_LOADING":
            return {
                ...state,
                commentSaveLoadingByDocument: {
                    ...state.commentSaveLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
            };

        case "SET_KMS_DOCUMENT_SUBSCRIPTION_LOADING":
            return {
                ...state,
                subscriptionLoadingByDocument: {
                    ...state.subscriptionLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
                subscriptionErrorByDocument: {
                    ...state.subscriptionErrorByDocument,
                    [action.payload.documentId]: action.payload.loading
                        ? null
                        : state.subscriptionErrorByDocument[action.payload.documentId],
                },
            };

        case "SET_KMS_DOCUMENT_SUBSCRIPTION_SAVE_LOADING":
            return {
                ...state,
                subscriptionSaveLoadingByDocument: {
                    ...state.subscriptionSaveLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
            };

        case "SET_KMS_DOCUMENT_RATING_LOADING":
            return {
                ...state,
                ratingLoadingByDocument: {
                    ...state.ratingLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
                ratingErrorByDocument: {
                    ...state.ratingErrorByDocument,
                    [action.payload.documentId]: action.payload.loading
                        ? null
                        : state.ratingErrorByDocument[action.payload.documentId],
                },
            };

        case "SET_KMS_DOCUMENT_RATING_SAVE_LOADING":
            return {
                ...state,
                ratingSaveLoadingByDocument: {
                    ...state.ratingSaveLoadingByDocument,
                    [action.payload.documentId]: action.payload.loading,
                },
            };

        case GET_KMS_DOCUMENTS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                lastFilters: action.payload.filters || {},
                error: null,
            };

        case GET_KMS_ARCHIVED_DOCUMENTS_SUCCESS:
            return {
                ...state,
                archivedItems: action.payload || [],
                error: null,
            };

        case GET_KMS_TRASHED_DOCUMENTS_SUCCESS:
            return {
                ...state,
                trashedItems: action.payload || [],
                error: null,
            };

        case GET_KMS_DOCUMENTS_BY_REPERTOIRE_SUCCESS:
            return {
                ...state,
                byRepertoire: {
                    ...state.byRepertoire,
                    [action.payload.repertoireId]: action.payload.items || [],
                },
                error: null,
            };

        case GET_KMS_DOCUMENTS_BY_CONTENT_SUCCESS:
            return {
                ...state,
                byContent: {
                    ...state.byContent,
                    [action.payload.contentId]: action.payload.items || [],
                },
                error: null,
            };

        case GET_KMS_DOCUMENT_SUCCESS:
            return {
                ...state,
                currentDocument: action.payload,
                error: null,
            };

        case GET_KMS_DOCUMENT_COMMENTS_SUCCESS:
            return {
                ...state,
                commentsByDocument: {
                    ...state.commentsByDocument,
                    [action.payload.documentId]: action.payload.items || [],
                },
                commentsLoadingByDocument: {
                    ...state.commentsLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                commentsErrorByDocument: {
                    ...state.commentsErrorByDocument,
                    [action.payload.documentId]: null,
                },
            };

        case GET_KMS_DOCUMENT_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscriptionByDocument: {
                    ...state.subscriptionByDocument,
                    [action.payload.documentId]: action.payload.subscription || { documentId: action.payload.documentId, subscribed: false },
                },
                subscriptionLoadingByDocument: {
                    ...state.subscriptionLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                subscriptionErrorByDocument: {
                    ...state.subscriptionErrorByDocument,
                    [action.payload.documentId]: null,
                },
            };

        case GET_KMS_DOCUMENT_RATING_SUMMARY_SUCCESS:
            return {
                ...state,
                ratingSummaryByDocument: {
                    ...state.ratingSummaryByDocument,
                    [action.payload.documentId]: action.payload.summary || null,
                },
                ratingLoadingByDocument: {
                    ...state.ratingLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                ratingErrorByDocument: {
                    ...state.ratingErrorByDocument,
                    [action.payload.documentId]: null,
                },
            };

        case CREATE_KMS_DOCUMENT_COMMENT_SUCCESS:
        case DELETE_KMS_DOCUMENT_COMMENT_SUCCESS:
            return {
                ...state,
                commentSaveLoadingByDocument: {
                    ...state.commentSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                commentsErrorByDocument: {
                    ...state.commentsErrorByDocument,
                    [action.payload.documentId]: null,
                },
                commentMutationTickByDocument: {
                    ...state.commentMutationTickByDocument,
                    [action.payload.documentId]: (state.commentMutationTickByDocument[action.payload.documentId] || 0) + 1,
                },
            };

        case SUBSCRIBE_KMS_DOCUMENT_SUCCESS:
        case UNSUBSCRIBE_KMS_DOCUMENT_SUCCESS:
            return {
                ...state,
                subscriptionByDocument: {
                    ...state.subscriptionByDocument,
                    [action.payload.documentId]: action.payload.subscription || {
                        documentId: action.payload.documentId,
                        subscribed: action.type === SUBSCRIBE_KMS_DOCUMENT_SUCCESS,
                    },
                },
                subscriptionSaveLoadingByDocument: {
                    ...state.subscriptionSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                subscriptionErrorByDocument: {
                    ...state.subscriptionErrorByDocument,
                    [action.payload.documentId]: null,
                },
                subscriptionMutationTickByDocument: {
                    ...state.subscriptionMutationTickByDocument,
                    [action.payload.documentId]: (state.subscriptionMutationTickByDocument[action.payload.documentId] || 0) + 1,
                },
            };

        case UPSERT_KMS_DOCUMENT_RATING_SUCCESS:
            return {
                ...state,
                ratingSummaryByDocument: action.payload.summary
                    ? {
                        ...state.ratingSummaryByDocument,
                        [action.payload.documentId]: action.payload.summary,
                    }
                    : state.ratingSummaryByDocument,
                ratingSaveLoadingByDocument: {
                    ...state.ratingSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                ratingErrorByDocument: {
                    ...state.ratingErrorByDocument,
                    [action.payload.documentId]: null,
                },
                ratingMutationTickByDocument: {
                    ...state.ratingMutationTickByDocument,
                    [action.payload.documentId]: (state.ratingMutationTickByDocument[action.payload.documentId] || 0) + 1,
                },
            };

        case UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_SUCCESS:
        case UPLOAD_KMS_DOCUMENT_TO_CONTENT_SUCCESS:
            return {
                ...state,
                message: "Document ajoute avec succes",
                error: null,
            };

        case UPDATE_KMS_DOCUMENT_SUCCESS:
            return {
                ...state,
                currentDocument: action.payload,
                message: "Document mis à jour avec succès",
                error: null,
            };

        case CHANGE_KMS_DOCUMENT_STATUS_SUCCESS:
            return {
                ...state,
                currentDocument: action.payload,
                message: "Statut du document mis a jour avec succes",
                error: null,
            };

        case DELETE_KMS_DOCUMENT_SUCCESS: {
            const { documentId, repertoireId, contentId } = action.payload;
            const byRepertoire = { ...state.byRepertoire };
            const byContent = { ...state.byContent };

            if (repertoireId && byRepertoire[repertoireId]) {
                byRepertoire[repertoireId] = byRepertoire[repertoireId].filter((item) => item.id !== documentId);
            }

            if (contentId && byContent[contentId]) {
                byContent[contentId] = byContent[contentId].filter((item) => item.id !== documentId);
            }

            return {
                ...state,
                byRepertoire,
                byContent,
                currentDocument: state.currentDocument?.id === documentId ? null : state.currentDocument,
                message: "Document supprimé avec succès",
                error: null,
            };
        }

        case RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_SUCCESS:
            return {
                ...state,
                archivedItems: state.archivedItems.filter((item) => item.id !== action.payload?.id),
                currentDocument: state.currentDocument?.id === action.payload?.id ? action.payload : state.currentDocument,
                message: "Document restauré depuis les archives",
                error: null,
            };

        case RESTORE_KMS_DOCUMENT_FROM_TRASH_SUCCESS:
            return {
                ...state,
                trashedItems: state.trashedItems.filter((item) => item.id !== action.payload?.id),
                currentDocument: state.currentDocument?.id === action.payload?.id ? action.payload : state.currentDocument,
                message: "Document restauré depuis la corbeille",
                error: null,
            };

        case HARD_DELETE_KMS_DOCUMENT_SUCCESS: {
            const { documentId, source } = action.payload;

            return {
                ...state,
                archivedItems: source === "archive"
                    ? state.archivedItems.filter((item) => item.id !== documentId)
                    : state.archivedItems,
                trashedItems: source === "trash"
                    ? state.trashedItems.filter((item) => item.id !== documentId)
                    : state.trashedItems,
                currentDocument: state.currentDocument?.id === documentId ? null : state.currentDocument,
                message: "Document supprimé définitivement",
                error: null,
            };
        }

        case GET_KMS_DOCUMENTS_FAIL:
        case GET_KMS_ARCHIVED_DOCUMENTS_FAIL:
        case GET_KMS_TRASHED_DOCUMENTS_FAIL:
        case GET_KMS_DOCUMENTS_BY_REPERTOIRE_FAIL:
        case GET_KMS_DOCUMENTS_BY_CONTENT_FAIL:
        case GET_KMS_DOCUMENT_FAIL:
        case UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_FAIL:
        case UPLOAD_KMS_DOCUMENT_TO_CONTENT_FAIL:
        case UPDATE_KMS_DOCUMENT_FAIL:
        case CHANGE_KMS_DOCUMENT_STATUS_FAIL:
        case ARCHIVE_KMS_DOCUMENT_FAIL:
        case DELETE_KMS_DOCUMENT_FAIL:
        case RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_FAIL:
        case RESTORE_KMS_DOCUMENT_FROM_TRASH_FAIL:
        case HARD_DELETE_KMS_DOCUMENT_FAIL:
            return { ...state, error: action.error };

        case GET_KMS_DOCUMENT_COMMENTS_FAIL:
            return {
                ...state,
                commentsLoadingByDocument: {
                    ...state.commentsLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                commentsErrorByDocument: {
                    ...state.commentsErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case GET_KMS_DOCUMENT_SUBSCRIPTION_FAIL:
            return {
                ...state,
                subscriptionLoadingByDocument: {
                    ...state.subscriptionLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                subscriptionErrorByDocument: {
                    ...state.subscriptionErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case GET_KMS_DOCUMENT_RATING_SUMMARY_FAIL:
            return {
                ...state,
                ratingLoadingByDocument: {
                    ...state.ratingLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                ratingErrorByDocument: {
                    ...state.ratingErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case CREATE_KMS_DOCUMENT_COMMENT_FAIL:
        case DELETE_KMS_DOCUMENT_COMMENT_FAIL:
            return {
                ...state,
                commentSaveLoadingByDocument: {
                    ...state.commentSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                commentsErrorByDocument: {
                    ...state.commentsErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case SUBSCRIBE_KMS_DOCUMENT_FAIL:
        case UNSUBSCRIBE_KMS_DOCUMENT_FAIL:
            return {
                ...state,
                subscriptionSaveLoadingByDocument: {
                    ...state.subscriptionSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                subscriptionErrorByDocument: {
                    ...state.subscriptionErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case UPSERT_KMS_DOCUMENT_RATING_FAIL:
            return {
                ...state,
                ratingSaveLoadingByDocument: {
                    ...state.ratingSaveLoadingByDocument,
                    [action.payload.documentId]: false,
                },
                ratingErrorByDocument: {
                    ...state.ratingErrorByDocument,
                    [action.payload.documentId]: action.error,
                },
            };

        case CLEAR_KMS_DOCUMENT_MESSAGE:
            return { ...state, message: "" };
        case CLEAR_KMS_DOCUMENT_ERROR:
            return { ...state, error: null };
        default:
            return state;
    }
}
